import store from '@/store';
import { isArray } from './is';
import Type from '@/store/mutation-type';
import { getSessionItem, setSessionItem } from './utils';

export const symbol = 'SYS_TITLE';

export function setTitleByUrlFlag() {
  const res = /systemFlag=(\d+)/.exec(location.href);
  if (isArray(res) && res[1]) {
    setTitle(res[1]);
  }
}

export function getTitle(key) {
  // 域名
  const hostName = window.location.hostname;
  const domainNameDict = {
    'mh.novasensingtech.com': '棉花阴燃综合监控系统',
    'novasensingtech.com': '棉花阴燃综合监控系统',
    'www.novasensingtech.com': '棉花阴燃综合监控系统'
  };
  if (domainNameDict[hostName]) {
    return domainNameDict[hostName];
  }

  const dict = {
    1: '核生化安保系统',
    2: '北京地铁人物同检工程',
    3: '海关',
    4: '化工园区网格化监测',
    5: '智慧边防管理系统',
    6: '华泰诺安测试平台'
  };

  return dict[key] || getSessionItem(symbol) || '华泰数据管理平台';
}

/**
 * 设置网站标题和登陆页面名称
 * @param {string} key
 */
export function setTitle(key) {
  const title = getTitle(key);
  setSessionItem(symbol, title);
  store.commit(`app/${Type.SET_TITLE}`, title);
  document.title = title;
}

export function syncTitle() {
  setTitle();
}
